import { ITableData, Header } from '../../../../pricing-simulator/types/generic-table.model';

export default function flattenColumnsHeader(pricingSimulationData: ITableData) {
    let result: Header[] = [];
    
    const flat = (headerData: Header[]) => {
        headerData.forEach((a) => {
            if (a) {
                result.push(a);
            }
            if (Array.isArray(a.children) && a.children.length) {
                flat(a.children);
            }
        });
    };

    flat(pricingSimulationData.header);
    return result;
}